// extracted by mini-css-extract-plugin
export default {"root":"MultiSelectDropdown_root__tIQ8w","chipRemoveInner":"MultiSelectDropdown_chipRemoveInner__GGqU7"};